module.exports = __webpack_public_path__ + "site/img/287.19abf423.jpg";